import React, { useState, useEffect, useRef } from "react";
import Scheduler, {
	AppointmentDragging,
	Resource,
} from "devextreme-react/scheduler";
import Query from "devextreme/data/query";

import Appointment from "./Appointment.jsx";
import AppointmentTooltip from "./AppointmentTooltip.jsx";
import AppointmentModal from "./AppointmentModal.jsx";
import WaitingListForm from "../Appointments/AddEditWaitingList";

import { toastify } from "../../../helperFunctions/toastify.js";
import { authorizedRequests } from "../../../axios/axios-config.js";
import { useDispatch, useSelector } from "react-redux";
import { resetValue, setData } from "../../../redux/slices/StaffFormsSlices.js";
import { Button, Modal } from "react-bootstrap";
import { getListOfHolidays } from './../../../apis/holidays'

const groups = ["locationId"];

function App(props) {
	const dispatch = useDispatch();

	const { rosteringCardData } = useSelector((state) => state.staffForm);
	const [data, setSchedularData] = useState(props.data);
	const doubleClickTimeout = useRef(null);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [isModalWaitingOpen, setIsModalWaitingOpen] = useState(false);
	const [branches, setBranches] = useState([]);
	// const [loading, setLoading] = useState(true);
	const [oldData, setOldData] = useState();
	const [newData, setNewData] = useState();
	const [isAppointment, setIsAppointment] = useState(true);
	const [waitingObj, setWaitingObj] = useState({});
	const [shouldOpenModal, setShouldOpenModal] = useState(true);

	const handleCellClick = (e) => {
		if (doubleClickTimeout.current) {
			clearTimeout(doubleClickTimeout.current);
			doubleClickTimeout.current = null;

			if (e.cellData) {
				// open waiting list
				if (e.cellData.groups?.locationId === 0) {
					setIsModalWaitingOpen(true);
				} else {
					// open apponitment
					const startTime = `${e.cellData.startDate?.getHours() + ":" + e.cellData.startDate?.getMinutes()}`;
					const endTime = `${e.cellData.endDate?.getHours() + ":" + e.cellData.endDate?.getMinutes()}`
					const branch = branches.find((o) =>
						o.location.find(
							(k) =>
								k._id == e?.cellData?.groups?.locationId,
						),
					);

					dispatch(resetValue("appointmentForm"));
					setIsAppointment(true);
					setWaitingObj({});
					setNewData({
						startTime,
						endTime,
						branch
					});
					if (shouldOpenModal) setIsModalOpen(true);
				}

			}
		} else {
			doubleClickTimeout.current = setTimeout(() => {
				clearTimeout(doubleClickTimeout.current);
				doubleClickTimeout.current = null;
			}, 300); // Adjust the timeout duration to your preference
		}
	};


	const onDrag = async (e) => {
		const { newData, oldData } = e;
		if (newData.locationId == 0 && oldData.locationId != 0) {
			e.cancel = true;
			toastify("Can't drop appointment into waiting list");
			return;
		}
		if (newData.locationId == 0 && oldData.locationId == 0) {
			const startTime = `${newData.startDate.getHours() +
				":" +
				newData.startDate.getMinutes()
				}`;
			const endTime = `${newData.endDate.getHours() + ":" + newData.endDate.getMinutes()
				}`;
			const { result, error } = await authorizedRequests({
				url: "waitingList/updateWaitingList",
				method: "post",
				data: {
					dataId: newData.id,
					startTime: startTime,
					endTime: endTime,
				},
			});
			if (error) {
				toastify(error.message, "error");
				e.cancel = true;
				return;
			}
			var tempArr = [...rosteringCardData],
				tempArr = tempArr.map((o) => {
					if (o._id == newData.id) {
						return { ...o, startTime: startTime, endTime };
					} else return o;
				});
			dispatch(
				setData({
					parent: "rosteringCardData",
					value: [...tempArr],
				}),
			);
			return;
		}
		if (newData.locationId != 0 && oldData.locationId != 0) {
			dispatch(resetValue("appointmentForm"));

			setIsAppointment(true);
			const startTime = `${newData.startDate.getHours() +
				":" +
				newData.startDate.getMinutes()
				}`;
			const endTime = `${newData.endDate.getHours() + ":" + newData.endDate.getMinutes()
				}`;
			// const originalData = rosteringCardData;
			// const originalSchedularData = data;
			// const tempArr = originalData.map((o) => {
			// 	if (o._id == newData.id) {
			// 		return {
			// 			...o,
			// 			location: newData.locationId,
			// 			branch: startTime,
			// 			endTime,
			// 		};
			// 	}
			// 	return o;
			// });
			const branch = branches.find((o) =>
				o.location.find((k) => k._id == newData.locationId),
			);
			setNewData({ ...newData, startTime, endTime, branch: branch });
			setOldData(oldData);
			// const filteredArray = tempArr.filter((o) => {
			// 	return o._id == newData.id;
			// });

			// const tempSchedularData = originalSchedularData.map((o) => {
			// 	if (o.id == newData.id) {
			// 		return {
			// 			...o,
			// 			location: newData.location,
			// 			startTime,
			// 			endTime,
			// 		};
			// 	}
			// 	return o;
			// });

			setIsModalOpen(true);
			// })

			// setOldData(oldData);
			// setIsModalOpen(true);
		}
		if (newData.locationId != 0 && oldData.locationId == 0) {
			dispatch(resetValue("appointmentForm"));
			setIsAppointment(false);
			const startTime = `${newData.startDate.getHours() +
				":" +
				newData.startDate.getMinutes()
				}`;
			const endTime = `${newData.endDate.getHours() + ":" + newData.endDate.getMinutes()
				}`;
			const allUserData = rosteringCardData.find(
				(o) => o?._id == newData?.id,
			);
			setWaitingObj({
				isFromWaiting: true,
				patient: allUserData.patientName,
				gender: allUserData?.gender,
				waitingId: allUserData?._id,
			});

			setIsModalOpen(true);
			// const { result, error } = await authorizedRequests({
			// 	url: "patient/addPatient",
			// 	method: "post",
			// 	data: {
			// 		patientProfile: {
			// 			fullName: allUserData.patientName,
			// 			gender: allUserData?.gender,
			// 		},
			// 	},
			// });
			// if (error) {
			// 	toastify(error.message ?? "unknown error occured", "error");
			// 	setIsModalOpen(false);
			// 	return;
			// }
			// const id = result.data._id;
			const branch = branches.find((o) =>
				o.location.find((k) => k._id == newData.locationId),
			);
			dispatch(
				setData({
					parent: "appointmentForm",
					value: {
						patient: -1,
						branch: branch._id,
						location: newData.locationId,
						startTime: startTime,
						endTime: endTime,
						date: allUserData.date,
						package: "",
						staff: [],
						tag: "",
						status: "",
						remarks: allUserData.remarks,
						formStatus: "New",
						editId: null,
					},
				}),
			);

			setNewData({ ...newData, startTime, endTime, branch });
			setOldData(oldData);
		}
		// e.cancel = true;
	};

	const listOfHolidays = async () => {
		const { result } = await getListOfHolidays()
		const holiday = result?.data.find((c) => (new Date(c?.eventDate).toLocaleDateString() === new Date(props.currentDate).toLocaleDateString()))
		let divElement = document.querySelector('.dx-scheduler-date-table-scrollable');
		if (divElement) {
			if (holiday) {
				divElement.style.backgroundColor = 'lightgrey';
			} else {
				divElement.style.backgroundColor = 'white';
			}
		}
	}

	useEffect(() => {
		listOfHolidays()
	})

	useEffect(() => {
		(async () => {
			const { result, error } = await authorizedRequests({
				url: "branch/listOfBranch",
				method: "get",
			});
			if (error) {
				toastify(error.message ?? "Failed to get branches", "error");
				return;
			}
			setBranches(result.data);
		})();
	}, []);

	useEffect(() => {
		props.setLoading(true);
		setSchedularData(props.data);
		const id = setTimeout(() => {
			props.setLoading(false);
		}, 1000);
		return () => {
			clearTimeout(id);
		};
	}, [props.data]);

	useEffect(() => {
		const id = setTimeout(() => {
			props.setLoading(false);
		}, 1000);
		return () => {
			clearTimeout(id);
		};
	}, []);
	const CustomResourceCell = (props) => {
		return <div style={{ color: "#34556F" }}>{props.data.text}</div>;
	};
	const CustomAppointmentTemplate = (props) => {
		return <div style={{ margin: "0" }}>{props.text}</div>;
	};
	return (
		<>
			{!props.loading ? (
				<>
					<Scheduler
						editing={{
							allowAdding: false,
							allowDeleting: false,
							allowResizing: false,
						}}
						// timeZone="America/Los_Angeles"
						dataSource={data}
						adaptivityEnabled
						views={["day"]}
						defaultCurrentView="day"
						defaultCurrentDate={props.currentDate}
						groups={groups}
						height={780}
						onAppointmentUpdating={(e) => {
							onDrag(e);
						}}
						firstDayOfWeek={0}
						startDayHour={0}
						endDayHour={23}
						showAllDayPanel={false}
						crossScrollingEnabled={true}
						cellDuration={30}
						onAppointmentClick={(e) => {
							e.cancel = true;
							const startTime = `${e?.appointmentData?.startDate.getHours() +
								":" +
								e?.appointmentData?.startDate.getMinutes()
								}`;
							const endTime = `${e?.appointmentData?.endDate.getHours() +
								":" +
								e?.appointmentData?.endDate.getMinutes()
								}`;
							const branch = branches.find((o) =>
								o.location.find(
									(k) =>
										k._id == e?.appointmentData?.locationId,
								),
							);

							if (e?.appointmentData?.locationId != 0) {
								dispatch(resetValue("appointmentForm"));

								setIsAppointment(true);
								setWaitingObj({});
								setNewData({
									...e?.appointmentData,
									startTime,
									endTime,
									branch: branch,
								});
								setOldData({ ...e?.appointmentData });
								if (shouldOpenModal) setIsModalOpen(true);
							} else if (e?.appointmentData?.locationId == 0) {
								dispatch(resetValue("appointmentForm"));
								setIsAppointment(false);
								const allUserData = rosteringCardData.find(
									(o) => o?._id == e?.appointmentData?.id,
								);
								setWaitingObj({
									isFromWaiting: true,
									patient: allUserData.patientName,
									gender: allUserData?.gender,
									waitingId: allUserData?._id,
								});
								dispatch(
									setData({
										parent: "appointmentForm",
										value: {
											patient: -1,
											startTime: startTime,
											endTime: endTime,
											date: allUserData.date,
											package: "",
											staff: [],
											tag: "",
											status: "",
											remarks: allUserData.remarks,
											formStatus: "New",
											editId: null,
										},
									}),
								);
								setNewData({
									...e?.appointmentData,
									startTime,
									endTime,
									branch,
								});
								setOldData(e?.appointmentData);
								if (shouldOpenModal) setIsModalOpen(true);
							}
						}}
						appointmentComponent={(e) => {
							const selectedSession = props.sessionList?.find(x => x.appointment?._id === e?.data?.appointmentData?.id);
							const selectedBilling = props.billingList?.find(x => x.session?._id === selectedSession?._id);

							return (
								<>
									<Appointment
										model={e}
										statusSession={selectedSession ? selectedSession.status : ""}
										isPayed={selectedBilling ? selectedBilling.isPayed : false}
										statusRostering={props.statusRostering}
										setRefreshAppointments={
											props.setRefreshAppointments
										}
										setIsModalOpen={(val) => {
											setShouldOpenModal(val);
										}}
									/>
								</>
							);
						}}
						onAppointmentDblClick={(e) => {
							e.cancel = true;
						}}
						onCellClick={handleCellClick}
						resourceCellComponent={CustomResourceCell}
					>
						<AppointmentDragging group={groups} />
						<Resource
							dataSource={data}
							fieldExpr="id"
							useColorAsDefault={true}
						/>
						<Resource
							dataSource={props.locations}
							fieldExpr="locationId"
						/>
					</Scheduler>
					<Modal
						centered
						className="p-5 schedularModal waitingModal"
						show={isModalWaitingOpen}
						onHide={() => {
							setIsModalWaitingOpen(!isModalWaitingOpen);
						}}
					>
						<Modal.Body>
							<div>
								<WaitingListForm />
							</div>
						</Modal.Body>
						<Modal.Footer></Modal.Footer>
					</Modal>
					<Modal
						centered
						className="p-5 schedularModal"
						show={isModalOpen}
						onHide={() => {
							setSchedularData(
								data.map((o) => {
									if (o.id == oldData?.id) {
										return oldData;
									} else return o;
								}),
							);
							// props.setRefreshAppointments((val) => !val);
							setIsModalOpen(!isModalOpen);
						}}
					>
						<Modal.Body>
							<div>
								<AppointmentModal
									setRefreshAppointments={
										props.setRefreshAppointments
									}
									updatedData={newData}
									isAppointment={isAppointment}
									waitingData={waitingObj}
									onCancel={() => {
										setSchedularData(
											data.map((o) => {
												if (o.id == oldData?.id) {
													return oldData;
												} else return o;
											}),
										);

										setIsModalOpen(!isModalOpen);
									}}
									setSchedularData={setSchedularData}
									setIsModalOpen={setIsModalOpen}
									schedularData={data}
								/>
							</div>
						</Modal.Body>
						<Modal.Footer></Modal.Footer>
					</Modal>
				</>
			) : (
				<>
					<div
						className="df-center"
						style={{
							height: "780px",
							width: "50vw",
						}}
					>
						<div className="spinner-border"></div>
					</div>
				</>
			)}
		</>
	);
}

export default App;
